'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getErrorMessage = require('./get-error-message');
var _getErrorMessage2 = _interopRequireDefault(_getErrorMessage);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.default = function () {
  var errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Please enter a valid postcode';
  return function (value, values) {
    if (typeof value === 'string') {
      var postcode = value.replace(/ /g, '');
      if (/^[A-Z]{1,2}[0-9]{2,3}[A-Z]{2}$/.test(postcode) || /^[A-Z]{1,2}[0-9]{1}[A-Z]{1}[0-9]{1}[A-Z]{2}$/.test(postcode) || /^GIR0[A-Z]{2}$/.test(postcode)) {
        return '';
      }
    }
    return (0, _getErrorMessage2.default)(errorMessage, {
      value: value,
      values: values
    });
  };
};